<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <div>
                  
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="650"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center px-4 py-2 text-right popup-header">
                <div
                  class="fs-16 font_weight_700">
                  {{ form.id === '' ? 'Tambah' : 'Ubah' }} {{ $route.meta.title }}
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="22"
                  color="#9ca3af">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <ValidationObserver 
                  ref="form">
                  <v-form>
  
                    <ValidationProvider 
                      name="Sekolah"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Sekolah
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
                        v-on:change="changeSchool()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. SMP"
  
                        :readonly="user.school_id !== undefined && user.school_id !== null ? true : false"
  
                        :items="school"
                        item-text="name"
                        item-value="id"
                        :item-color="set_color"
  
                        v-model="form.school_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>


                    <ValidationProvider 
                      name="Nama Modul" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Nama Modul
                        <span class="red--text">*</span>
                      </div>

                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        solo
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. IPA"

                        

                        v-model="form.modul_name"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;"
                        class="mb-0">
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nama Pegawai"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Nama Pegawai
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Piilih Pegawai"
  
                        
  
                        :items="pegawai"
                        item-text="name"
                        item-value="id"
                        :item-color="set_color"
  
                        v-model="form.pegawai_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nama Mata Pelajaran"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Nama Mata Pelajaran
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Pilih Mata Pelajaran"
  
                        
  
                        :items="mapel"
                        item-text="name"
                        item-value="id"
                        :item-color="set_color"
  
                        v-model="form.mapel_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>
  
                    <ValidationProvider 
                      name="Tahun Ajaran"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Tahun Ajaran
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. 2025"
  
                        
  
                        :items="tahun_ajaran"
                        item-text="value"
                        item-value="id"
                        :item-color="set_color"
                        v-on:change="tahun_ajaran.filter(item => item.id === form.tahun_ajaran_id).map(item => form.tahun_ajaran_value = item.value)"
  
                        v-model="form.tahun_ajaran_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete> 
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Uraian Modul" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Uraian Modul
                        <span class="red--text">*</span>
                      </div>

                      <v-textarea
                        v-on:keyup.enter="save()"
                        
                        solo
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. Uraian Modul"

                        

                        v-model="form.uraian"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;"
                        class="mb-0">
                      </v-textarea>
                    </ValidationProvider>

                    <div>
                      <div class="fs-13 mb-1">
                        
                        File Modul
                        <span class="red--text">*</span>
                      </div>
  
                      <v-row>
                        <v-col
                          cols="12" v-if="form.file_url === '' || form.file_url === null">
                          <uploadfile
                            v-model="upload.document" >
                            <div 
                              slot="activator"
                              class="cursor-pointer">
                              <v-card
                                flat
                                class="cursor-pointer"
                                style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                                <v-card-text
                                  class="py-2">
                                  <div v-if="!process.document"
                                    class="d-flex align-center justify-center">
                                    <v-icon 
                                      size="28" 
                                      color="#b6b6b6">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <div
                                      class="black--text ml-2"
                                      style="opacity: 40%; font-weight: 500;">
                                      Upload File
                                    </div>
                                  </div>

                                  <div v-if="process.document"
                                    class="text-center">
                                    <v-progress-circular
                                      indeterminate
                                      size="28"
                                      color="#b6b6b6">
                                    </v-progress-circular>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </uploadfile>
                        </v-col>
                        <v-col cols="12" v-if="form.file_url !== '' && form.file_url !== null">
                          <v-card
                            flat
                            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                            <v-icon
                              @click="form.file_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>

                            <v-card-text
                              class="py-3 line-text-second">
                              <div
                                class="d-flex align-center">
                                <div style="width: 50px;">File</div> : <a :href="form.file_url" target="_blank" class="ml-1">{{ form.file_url }}</a>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>

              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>

              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>

                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-menu
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                      <v-spacer />
    
                      <div class="d-flex align-center">
                        <v-text-field
                          @click:clear="search = ''; fetch();"
                          v-on:keyup.enter="fetch()"
              
                          solo
                          rounded
                          dense
                          single-line
              
                          hide-details
                          :color="set_color"
                          placeholder="Cari data . . ."
                          prepend-inner-icon="mdi-magnify"
                          clearable
              
                          v-model="search"
                          class="fs-12 little-placeholder"
                          style="border-radius: 6px; background: #fff !important; max-width: 320px">
                        </v-text-field>

                        <v-autocomplete
                          v-on:change="fetch()"
              
                          solo
                          rounded
                          dense
                          single-line
              
                          hide-details
                          :color="set_color"
                          placeholder="Pilih Sekolah"
                          prepend-inner-icon="mdi-magnify"
                          :items="school"
                          item-text="name"
                          item-value="id"
                          v-if="(user.school_id === undefined || user.school_id === null) &&($store.state.school === null || $store.state.school === undefined || undefined === '')"
              
                          v-model="filter.school_id"
                          class="fs-12 little-placeholder ml-3"
                          style="border-radius: 6px; background: #fff !important; max-width: 400px">
                        </v-autocomplete>
  
                        <v-btn
                          @click="dialog.form = true; reset();"
                          :color="set_color"
                          elevation="0"
                          small
                          min-height="36"
                          class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                          style="border-radius: 6px; font-weight: 600;">
                          <span
                            class="ml-0">
                            Tambah
                          </span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text v-if="filter.school_id === '' || filter.school_id === null">
                    <div
                      class="d-flex align-center justify-center" style="height: calc(100vh - 250px);">
                      <div>
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="100"
                          :height="100"
                          :src="require('@/assets/icon/selective.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
    
                        <div 
                          class="font-weight-light text-second my-6">
                          Pilih <b>Sekolah</b> terlebih dahulu!!!
                        </div>
                      </div>
                    </div>

                  </v-card-text>
                  <v-card-text v-if="filter.school_id !== '' && filter.school_id !== null">
                    <v-data-table
                      v-model="selected.row"
                      ref="table-grid"
                      class="table-grid"
                      :height="`calc(100vh - ${pagination.total_data > 0 ? '315px' : '248px'})`"
                      :show-select="checkbox"
                      :single-select="true"
                      :loading="process.load"
                      loading-text="Sedang memuat data . . ."
                      loader-height="5"
                      no-results-text="Belum ada data"
                      :options.sync="options"
                      :headers="configHeaders"
                      :items="list"
                      :items-per-page="100"
                      item-key="id"
                      @click:row="rowClick"
                      @toggle-select-all="handleToggleAll($event)"
                      @dblclick:row="doubleClick"
                      hide-default-footer
                      hide-default-header>
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th v-for="h in headers" :key="h" :style="`min-width: ${h.width === '' ? '' : h.width }; width: ${h.width === '' ? '' : h.width };background-color: #f3f4f6 !important; color: #000 !important;`" :class="`text-${h.align}`">
                              <span>{{h.text}}</span>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template
                        v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                        v-slot:[`item.${header.value}`]="{ value, index, item }">
                        <div
                          v-bind:key="header.value">
                          <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                            {{ rowFormat(header.format, value) }} 
                          </div>
    
                          <div v-if="header.format === 'link'"
                            class="cursor-pointer">
                            <a :href="value" target="_blank">{{ value }}</a>
                          </div>
            
                          <div v-if="header.format === 'regex'">
                            <span
                              class="two-line">
                              {{ rowFormat(header.format, value) }}
                            </span>
                          </div>
            
                          <div v-if="header.format === 'image'"
                            class="ma-4">
                            <v-avatar
                              size="60"
                              tile
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="POS Amanata" 
                                :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      size="20"
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>
    
                          <div v-if="header.format === 'image_potrait'"
                            class="ma-4">
                            <v-img 
                              contain
                              width="100"
                              height="125"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
    
                          <div v-if="header.format === 'image_landscape'"
                            class="ma-4">
                            <v-img 
                              contain
                              width="200"
                              height="125"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
    
                          <div v-if="header.format === 'action'">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="reset(index); dialog.form = true;"
                                  
                                  v-bind="attrs"
                                  v-on="on"
    
                                  min-width="25"
                                  height="25"
                                  x-small
                                  rounded
                                  color="#3b3f5c"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 8px;">
                                  <v-icon size="13">mdi-pencil-outline</v-icon>
                                </v-btn>
                              </template>
    
                              <span>Ubah</span>
                            </v-tooltip>
    
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id)"
    
                                  v-bind="attrs"
                                  v-on="on"
    
                                  min-width="25"
                                  height="25"
                                  x-small
                                  rounded
                                  color="#e7515a"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 8px;">
                                  <v-icon size="13">mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <span>Hapus</span>
                            </v-tooltip>
    
                            <!-- <v-menu
                              right
                              offset-y
                              style="box-shadow: none !important;">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
    
                                  min-width="24" min-height="24"
                                  x-small
                                  rounded
                                  color="#37474F"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
    
                              <v-list
                                dense
                                color="#808080"
                                class="py-1 my-2"
                                style="border-radius: 10px !important;">
                                <v-list-item
                                  class="px-2">
                                  <v-tooltip 
                                    right>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="toRole(value)"
    
                                        v-bind="attrs"
                                        v-on="on"
    
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="indigo"
                                        elevation="0"
                                        class="white--text text-capitalize px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon small>mdi-account-settings-outline</v-icon>
                                      </v-btn>
                                    </template>
    
                                    <span>Hak Akses</span>
                                  </v-tooltip>
                                </v-list-item>
    
                                <v-list-item
                                  class="px-2">
                                  <v-tooltip 
                                    right>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="toReset(value)"
    
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="orange"
                                        elevation="0"
                                        class="white--text text-capitalize px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-lock-reset</v-icon>
                                      </v-btn>
                                    </template>
    
                                    <span>Reset Password</span>
                                  </v-tooltip>
                                </v-list-item>
                              </v-list>
                            </v-menu> -->
                          </div>
    
                          <div v-if="header.format === 'bool'"
                            class="d-flex align-center justify-center">
                            <!-- <v-switch
                              @change="toStatus(value, index)"
                              v-model="value"
                              color="success"
                              class="ma-auto"
                              hide-details>
                            </v-switch> -->
                          </div>
    
                          <div v-if="header.format === 'status'"
                            class="d-flex justify-center">
                            
                          </div>
                        </div>
                      </template>
    
                      <template v-slot:[`item.index`]="{ index }">
                        {{ lastIndex + index }}
                      </template>
    
                      <v-progress-linear 
                        v-show="process.load" 
                        slot="progress" 
                        color="white" 
                        indeterminate>
                      </v-progress-linear>
                    </v-data-table>
                    <pagination v-if="pagination.total_data > 0"
                      @changePage="fetch($event)" 
                      @reloadPage="fetch($event)" 
                      :model="pagination" :display="paginationList"/>
                  </v-card-text>
                  <!-- <div class="view">
                    <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                      <table style="border-radius: 10px; width: 100%;" class="table">
                        <tr>
                          <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'name' ? toSort('name') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Nama
                            <span v-if="sortBy === 'name'">
                              <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'cat_title' ? toSort('cat_title') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                            Kategori Pegawai
                            <span v-if="sortBy === 'cat_title'">
                              <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'email' ? toSort('email') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Email
                            <span v-if="sortBy === 'email'">
                              <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'mobilephone' ? toSort('mobilephone') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Telepon
                            <span v-if="sortBy === 'mobilephone'">
                              <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'input_datetime' ? toSort('input_datetime') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Dibuat Tanggal
                            <span v-if="sortBy === 'input_datetime'">
                              <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th :style="`background-color: ${set_color}; color: #fff;`" style=" color: white; font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center; width: 100%;"></th>
                          
                        </tr>
                        <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                          <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: center;">
                            <v-tooltip 
                              top
                              v-if="hak_akses.action.update">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="reset(index); dialog.form = true;"
                                  
                                  v-bind="attrs"
                                  v-on="on"
  
                                  min-width="28"
                                  small
                                  rounded
                                  color="blue"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-square-edit-outline</v-icon>
                                </v-btn>
                              </template>
  
                              <span>Ubah</span>
                            </v-tooltip>
  
                            <v-tooltip 
                              top
                              v-if="hak_akses.action.delete">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id)"
  
                                  v-bind="attrs"
                                  v-on="on"
  
                                  min-width="28"
                                  small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <span>Hapus</span>
                            </v-tooltip>
  
                            <v-tooltip 
                              right
                              v-if="hak_akses.action.reset_password">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toReset(item.id)"
  
                                  v-bind="attrs"
                                  v-on="on"
                                  
                                  min-width="28"
                                  small
                                  rounded
                                  color="orange"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-lock-reset</v-icon>
                                </v-btn>
                              </template>
  
                              <span>Reset Password</span>
                            </v-tooltip>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.name }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.cat_title }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.email }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.mobilephone }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 200px; min-width: 200px; padding: 8px 12px; text-align: left;">{{ item.input_datetime | datetime }}</td>
                          
                        </tr>
                      </table>
                    </div>
      
                    <v-card-text
                      v-if="process.load" 
                      class="pb-0 my-4" 
                      style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-4 title">
                          Mohon Tunggu . . .
                        </div>
      
                        <v-progress-linear
                          :color="set_color"
                          indeterminate
                          rounded
                          height="10">
                        </v-progress-linear>
                      </div>
                    </v-card-text>
      
                    <v-card-text
                      v-if="!process.load && list.length === 0"
                      class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="mt-3 fs-16">
                          Belum Ada Data
                        </div>
                      </div>
                    </v-card-text>
      
                    <pagination v-if="!process.load && pagination.total_data > 0"
                      @changePage="fetch($event)" 
                      @reloadPage="fetch($event)" 
                      :model="pagination" :display="paginationList"/>
      
                  </div> -->
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            delete: false,
            reset: false,
            role: false,
  
            filter: false,
            form: false
          },
          
          search: '',
  
          filter: {
            school_id: '',
          },
  
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },
          
          upload: {
            image: '',
            document: ''
          },
          selected: {
            row: [],
            freeze: [],
            delete: [],
            reset: [],
            role: []
          },
  
          paginationList: {
            row: 20,
            page: 1
          },
  
          role: [],
          sortBy: 'id',
          sortDesc: '-',
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          form: {
            id: '',
            school_id: '',
            pegawai_id: '',
            tahun_ajaran_id: '',
            tahun_ajaran_value: '',
            mapel_id: '',
            modul_name: '',
            uraian: '',
            file_url: ''
          },
  
          school: [],
          pegawai: [],
          kelas: [],
          tahun_ajaran: [],
          mapel: [],
  
          process: {
            load: false,
  
            delete: false,
            reset: false,
            role: false,
            export: false,
            image: false,
            form: false,
            document: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.logo_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.f.rab_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                this.form.file_url = this.upload.document.fileuri

                this.upload.document = null

                // this.f.rab_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
        '$store.state.school': function(val) {
          this.filter.school_id = val
          this.fetch()
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        data_menu () {
          let menu = {}
          this.$store.state.menu.map((item, index) => {
            if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
              item.sub_menu.map((sub, index) => {
                if (sub.link === this.$route.path) {
                  menu = sub
                }
              })
            }
          })
  
          return menu
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
        years () {
          let max = new Date('10-01-2023').getFullYear()+10, min = max - 10, years = []
          // console.log(new Date('10-01-2024').getFullYear())
  
          this.filter.year = this.$store.state.year
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      mounted () {
        this.fetch()
        this.fetchPegawai()
        // this.fetchKelas()
        this.fetchSchool()
        // this.fetchTahun()
        this.fetchMapel()
      },
      methods: {
        async fetchSchool() {
  
            let params = {
            limit: 10000000000000
          }

          
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.school = res.results.data
            }
          })
        },
        async fetchPegawai() {
  
           let params = {
            limit: 10000000000000,
            school_id: this.form.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/master/data' : 'pegawai/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.pegawai = res.results.data
            }
          })
        },

        async fetchMapel() {
  
           let params = {
            limit: 10000000000000,
            school_id: this.form.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/mapel/data' : 'mapel/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.mapel = res.results.data
            }
          })
        },
  
        async fetchKelas() {
  
           let params = {
            limit: 10000000000000,
            school_id: this.form.school_id
          }
  
          await get(`kelas/data`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.kelas = res.results.data
            }
          })
        },
        async fetchTahun() {
  
            let params = {
            limit: 10000000000000,
            school_id: this.form.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/tahun_ajaran/data' : 'tahun_ajaran/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.tahun_ajaran = res.results.data
            }
          })
        },
        changeSchool() {
          this.form.guru_mapel_id = ''
          this.form.kelas_id = ''
          this.fetchPegawai()
          this.fetchMapel()
          this.fetchTahun()
        },
        toSort(name) {
          this.sortBy = name
          this.sortDesc = ''
          this.fetch()
        },
        toDesc() {
          this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
          this.fetch()
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetch (pagination = { row: 20, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            sort: `${this.sortDesc}${this.sortBy}`,
            // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
            school_id: this.filter.school_id
          }
  
          this.selected.row = []

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/modul/data' : 'modul/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                // {
                //   text: 'Status',
                //   width: '100px',
                //   value: 'is_active',
                //   freeze: false,
                //   hide: false,
                //   align: 'center',
                //   format: 'bool'
                // },
                // {
                //   text: 'Nomor Induk Pegawai',
                //   width: '200px',
                //   value: 'nip',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Aksi',
                  width: '80px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'center',
                  format: 'action'
                },
                {
                  text: 'Nama Modul',
                  value: 'modul_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Nama Mapel',
                  width: '200px',
                  value: 'mapel_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Nama Pegawai',
                  width: '200px',
                  value: 'pegawai_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Tahun Ajaran',
                  width: ' 100px',
                  value: 'tahun_ajaran',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'File',
                  width: ' 100%',
                  value: 'file_url',
                  freeze: false,
                  hide: false,
                  format: 'link'
                }
              ]
  
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              this.list.map(obj => {
                obj.is_active = obj.is_active === '1' ? true : false
              })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = 'transparent'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? this.list[index].id : '',
            school_id: index !== undefined ? this.list[index].school_id : this.filter.school_id,
            pegawai_id: index !== undefined ? this.list[index].pegawai_id : '',
            tahun_ajaran_id: index !== undefined ? this.list[index].tahun_ajaran_id : '',
            tahun_ajaran_value: index !== undefined ? this.list[index].tahun_ajaran : '',
            mapel_id: index !== undefined ? this.list[index].mapel_id : '',
            modul_name: index !== undefined ? this.list[index].modul_name : '',
            uraian: index !== undefined ? this.list[index].uraian : '',
            file_url: index !== undefined ? this.list[index].file_url : ''
          }

          
          if(index === undefined && this.filter.school_id !== '' && this.filter.school_id !== null) {
            this.fetchPegawai()
            this.fetchMapel()
            this.fetchTahun()
          }

          if (index !== undefined) {
            this.fetchPegawai()
            this.fetchMapel()
            this.fetchTahun()
          }
  
          this.process.form = false
  
          this.message.error = ''
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/modul/add' : 'pegawai/modul/update' : this.form.id === '' ? 'modul/add' : 'modul/update'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                if (this.form.id === '') {
                  this.fetch()
                } else {
                  this.fetch(this.paginationList)
                }
                this.reset()
  
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/modul/delete' : 'modul/delete'
  
          await post(`${url}`, {
            data: {
              id: this.selected.delete[0],
              school_id: this.filter.school_id
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        },
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 5px;
    }
    table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }
  
  .view {
    margin: auto;
    /* width: 100%; */
  }
  
  .wrapper-pegawai { 
    overflow-y: auto; 
    height: calc(100vh - 265px); 
  } 
  
  .wrapper-pegawai-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 
  
  .wrapper-pegawai th { 
    position: sticky; 
    top: 0; 
    /* background-color: #080679 !important; */
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    /* background-color: #080679 !important; */
  }
  
  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }
  
  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }
  
  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }
  
  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }
  
  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
  </style>